import { PHONE_COUNTRY_CODE } from "../LoginUser/hook/phoneCountryCode";

const COUNTRY_ALIASES: Record<string, string> = {
	thai: "thailand",
	thailand: "thailand",
	turkiye: "turkey",
	czech: "czechia",
	czechrepublic: "czechia",
	ceska: "czechia",
	sec: "czechia",
	southafrica: "southafrica",
	namphi: "southafrica",
	ulaanbaatar: "mongolia",
	unitedstates: "unitedstates",
	usa: "unitedstates",
	us: "unitedstates",
};

export function normalizeCountryKey(value: any) {
	const normalized = String(value ?? "")
		.trim()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.toLowerCase()
		.replace(/[^a-z]/g, "");

	return COUNTRY_ALIASES[normalized] || normalized;
}

const canonicalCountryMap = new Map<string, string>();
for (const entry of PHONE_COUNTRY_CODE) {
	const key = normalizeCountryKey(entry?.name ?? "");
	if (key && !canonicalCountryMap.has(key)) {
		canonicalCountryMap.set(key, String(entry?.name ?? "").trim());
	}
}

export function toCanonicalCountryName(value: any) {
	const raw = String(value ?? "").trim();
	if (!raw) return "";
	return canonicalCountryMap.get(normalizeCountryKey(raw)) || raw;
}
